(function () {
  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var header = document.querySelector("header#header");

    var CONSULTATION_URL = "https://www.drsknn.uk/kiosk?tab=consultations";
    var TREATMENTS_URL = "https://www.drsknn.uk/kiosk?tab=treatments";

    function bootPricingModule() {
      if (typeof window.openDrSknnPricingModal === "function") return true;
      if (!document.getElementById("drsknn-pricing-modal")) return false;

      var scripts = document.querySelectorAll("script");
      for (var i = 0; i < scripts.length; i += 1) {
        var source = scripts[i].textContent || "";
        if (
          source.indexOf("window.openDrSknnPricingModal") === -1 ||
          source.indexOf("drsknn-pricing-modal-tile") === -1 ||
          scripts[i].hasAttribute("data-drsknn-pricing-boot-source")
        ) {
          continue;
        }

        scripts[i].setAttribute("data-drsknn-pricing-boot-source", "true");
        var runner = document.createElement("script");
        runner.setAttribute("data-drsknn-pricing-boot-runner", "true");
        runner.text = source;
        document.head.appendChild(runner);
        runner.parentNode.removeChild(runner);
        return typeof window.openDrSknnPricingModal === "function";
      }

      return false;
    }

    bootPricingModule();
    new MutationObserver(function () {
      bootPricingModule();
    }).observe(document.body, { childList: true, subtree: true });

    if (!header) return;

    function bookingUrlForLink(link) {
      var signal = [
        link.getAttribute("href") || "",
        link.textContent || "",
        link.getAttribute("aria-label") || ""
      ].join(" ").toLowerCase();
      if ((signal.indexOf("treatment") !== -1 || signal.indexOf("bookings") !== -1 || signal.indexOf("tab=treatments") !== -1) && signal.indexOf("consult") === -1) {
        return TREATMENTS_URL;
      }
      return CONSULTATION_URL;
    }

    function rewriteBookingLinks(root) {
      var links = (root || document).querySelectorAll("a[href*='connect.pabau.com/bookings.php'], a[href*='connect-uk1.pabau.me/bookings.php'], a[href*='drsknn.uk/kiosk'], a[href*='drsknn.online/book']");
      links.forEach(function (link) {
        link.setAttribute("href", bookingUrlForLink(link));
      });
    }

    rewriteBookingLinks(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) rewriteBookingLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    var trigger = header.querySelector(".header__btn-menu, [data-js-popup-button='navigation']");
    var nav = header.querySelector(".header__nav");
    if (!trigger || !nav) return;

    if (!nav.id) nav.id = "drsknn-online-mobile-menu";
    trigger.setAttribute("aria-controls", nav.id);
    trigger.setAttribute("aria-expanded", "false");

    function isMobile() {
      return window.matchMedia("(max-width: 1024px)").matches;
    }

    function setOpen(open) {
      document.body.classList.toggle("drsknn-mobile-menu-open", open);
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }

    trigger.addEventListener("click", function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(!document.body.classList.contains("drsknn-mobile-menu-open"));
    }, true);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") setOpen(false);
    });

    document.addEventListener("click", function (event) {
      if (!document.body.classList.contains("drsknn-mobile-menu-open")) return;
      if (!header.contains(event.target)) setOpen(false);
    });

    nav.addEventListener("click", function (event) {
      var link = event.target.closest("a[href]");
      if (link && link.getAttribute("href") !== "#") setOpen(false);
    });

    window.addEventListener("resize", function () {
      if (!isMobile()) setOpen(false);
    });
  });
}());
